import { render, staticRenderFns } from "./default-after-login-v1.vue?vue&type=template&id=f42299c4&lang=pug"
import script from "./default-after-login-v1.vue?vue&type=script&lang=js"
export * from "./default-after-login-v1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports